var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTechStack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "gray",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20v2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2v2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 20v2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 2v2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12h2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 17h2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7h2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12h2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17h2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M20 7h2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M7 20v2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7 2v2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 8,
    height: 8,
    rx: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTechStack);
export default __webpack_public_path__ + "static/media/icon-tech-stack.23e311aefde3561f1ae69b46fc9168b3.svg";
export { ForwardRef as ReactComponent };